export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13555.00fe02af.jpg";